import { CssBaseline } from '@mui/material';


export default function UnauthenticatedContainer({children}) {
    return <>
        <CssBaseline />
        {children}
    </>
}